import { createRootRoute, Outlet } from "@tanstack/react-router";

// Root route — the topmost frame every page renders inside. Keeps
// itself deliberately bare: just an <Outlet /> for child routes. The
// pathless `_app` layout underneath handles the protected shell, and
// `/login` lives outside it so unauthenticated users can reach the
// sign-in page.
//
// Nothing that requires auth goes here. The root runs on every page
// including /login, and we can't assume there's a session yet.
export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return <Outlet />;
}
